module.exports = __webpack_public_path__ + "static/img/banner.6f58256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgct/banner.jpg
// module id = mFlb
// module chunks = 23